
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { authKey, GET_CHIPPING_ORDER_LIST } from '../../../common/URLs';
import jwt from 'jwt-decode';
import { DataGrid } from '@mui/x-data-grid';
import { Container, Button, Box, Card, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab, Tooltip, CardContent, Grid, FormControl, TextField } from '@mui/material'
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import moment from 'moment';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { PROD, PIT_ROLES } from "../../../common/constants";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { toast } from 'react-toastify';
import { AddIcon, ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import dayjs from 'dayjs';

function PlantChippingOrders() {

    const navigate = useNavigate();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [chippingOrderDetails, setChippingOrderDetails] = useState([]);
    const [consignmentStatusList, setConsignmentStatusList] = useState();
    const [searchFilter, setSearchFilter] = useState({
        "chippingOrderFromDate": null,
        "chippingOrderToDate": null,
    });
    useEffect(() => {
        getChippingOrdersList();
    }, [searchFilter]);

    const onViewDetails = (cellValues) => {
        navigate('./plantChippingOperation', {
            state: { selectedRow: cellValues.row }
        });
    }

    const onAddChippingOperation = () => {
        navigate('./plantChippingOperation', {

        });
    }


    // useEffect(() => {
    //     getConsignmentStatusList();
    // }, []);

    // const getConsignmentStatusList = () => {
    //     loaderService.showLoader()
    //     apiClient
    //         .post(
    //             GET_CHIPPING_ORDER_LIST,
    //             {

    //             },
    //             {
    //                 headers: {
    //                     Authorization: "Bearer " + getLocalStorageItem('id_token'),
    //                 },
    //             },
    //             null
    //         )
    //         .then((response) => {
    //             setConsignmentStatusList(response.data.consignmentStatus);
    //             loaderService.hideLoader()
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //             loaderService.hideLoader()
    //             // toast.error(error.message);

    //         });
    // };

    const getChippingOrdersList = () => {
        let data = {
            "stakeholderUrn": "ABEPL",
            "chippingOrderFromDate": searchFilter?.chippingOrderFromDate,
            "chippingOrderToDate": searchFilter?.chippingOrderToDate
        }

        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader()
        apiClient
            .post(GET_CHIPPING_ORDER_LIST, data, { headers })
            .then(res => {
                res.data.chippingOrderList.sort((a, b) => {
                    if (a.chippingOrderNo < b.chippingOrderNo) {
                        return 1
                    } else {
                        return -1;
                    }
                })
                setChippingOrderDetails(res.data.chippingOrderList)
                loaderService.hideLoader()
            })
            .catch(function (err) {
                console.log(err);
                toast.error(err.message);
                loaderService.hideLoader()
            });
    };

    function searchAsnDetails(e) {
        e.preventDefault();
        getChippingOrdersList();
    }

    const columns = [
        { field: 'chippingOrderNo', headerName: 'Chipping Order No#', width: 190 },
        {
            field: 'chippingOrderDate', headerName: 'Chipping Order Date', width: 190,
            valueFormatter: params => params.value !== null ? moment(params?.value).format("DD/MM/YYYY") : "",
        },
        { field: 'chippingQuantity', headerName: 'Chipping Order Quantity (MT)', width: 180 },
        { field: 'rbQuantity', headerName: 'Consumed Raw bamboo Quantity (MT)', width: 200 },
        { field: 'preChippingQuantity', headerName: 'Pre-chiping Quantity (MT)', width: 160 },
        { field: 'postChippingQuantity', headerName: 'Post-chipping Quantity (MT)', width: 160 },
        { field: 'balanceQuantity', headerName: 'Heap Balance Quantity (MT)', width: 170 },
        { field: 'chippingStatus', headerName: 'Status', width: 210 },
        {
            field: 'Action', width: 80,
            renderCell: (cellValues) => {
                return (
                    <Tooltip title="View">
                        <IconButton
                            variant="contained"
                            color="primary"
                            onClick={() => onViewDetails(cellValues)}
                        >
                            <ViewIcon />
                        </IconButton>
                    </Tooltip>
                );
            }
        },
    ];

    const handleDateChange = (name, value) => {
        const formatted = value ? value.format("YYYY-MM-DD") : null;

        setSearchFilter((prev) => {
            if (
                name === "chippingOrderToDate" &&
                prev.chippingOrderFromDate &&
                dayjs(prev.chippingOrderFromDate).isAfter(value)
            ) {
                return {
                    ...prev,
                    chippingOrderToDate: formatted,
                    chippingOrderFromDate: formatted
                };
            }

            return {
                ...prev,
                [name]: formatted
            };
        });
    };

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT10</p>}
                <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                    <Typography variant="h4" gutterBottom>
                        Plant Chipping Orders
                    </Typography>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                        {localStorage.getItem('role') == PIT_ROLES.ProcessingIncharge ? null :
                            <>
                                <Stack direction="row" spacing={1}>
                                    <Button startIcon={<AddIcon />} sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onAddChippingOperation(e)} >
                                        Create Chipping Order
                                    </Button>
                                </Stack>
                            </>
                        }
                    </Stack>
                </Stack>
                <Card>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} lg={6}>
                                <FormControl fullWidth >
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            label="Chipping Order From Date"
                                            value={searchFilter?.chippingOrderFromDate ? dayjs(searchFilter.chippingOrderFromDate) : null}
                                            inputFormat="DD/MM/YYYY"
                                            maxDate={searchFilter?.chippingOrderToDate}
                                            onChange={(value) => handleDateChange("chippingOrderFromDate", value)}
                                            renderInput={(params) => (
                                                <TextField {...params} fullWidth />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <FormControl fullWidth >
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            label="Chipping Order To Date"
                                            value={searchFilter?.chippingOrderToDate ? dayjs(searchFilter.chippingOrderToDate) : null}
                                            inputFormat="DD/MM/YYYY"
                                            onChange={(value) => handleDateChange("chippingOrderToDate", value)}
                                            renderInput={(params) => (
                                                <TextField {...params} fullWidth />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={12}>
                                <Box sx={{ height: 450, width: "100%" }}>
                                    {
                                        chippingOrderDetails &&
                                        <DataGrid rows={chippingOrderDetails}
                                            columns={columns}
                                            pageSize={10}
                                            getRowId={(row) => row.chippingOrderNo}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                        />
                                    }
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
        </>
    );
}
export default PlantChippingOrders;
